import Font20 from '@assets/icons/font-20.svg'
import { Icon } from './Icon'

export const Font20Icon = Icon(Font20)
